export { CoinsChart as LoyaltyCoinsChart } from './CoinsChart';
